import { render, staticRenderFns } from "./LoanApplicationForm.vue?vue&type=template&id=b43f8d64&scoped=true&"
import script from "./LoanApplicationForm.vue?vue&type=script&lang=js&"
export * from "./LoanApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./LoanApplicationForm.vue?vue&type=style&index=0&id=b43f8d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43f8d64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
